import React from "react";
import { Helmet } from "react-helmet";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
// Screens
import Landing from "./screens/Landing.jsx";
import BlogDetail from "./screens/BlogDetail.jsx";
import AllBlogs from "./screens/AllBlogs.jsx";
import Application from "./screens/Application.jsx";
import TutorApplication from "./screens/TutorApplication.jsx";

export default function App() {
  return (
    <>
      <Helmet>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
        <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700;800;900&family=Montserrat:wght@400;500;600;700&display=swap" rel="stylesheet" />
      </Helmet>
      <Router>
        <Switch>
          <Route exact path="/" component={Landing} />
          <Route path="/blogs" component={AllBlogs} />
          <Route path="/blog/:id" component={BlogDetail} />
          <Route path="/apply" component={Application} />
          <Route path="/tutor-apply" component={TutorApplication} />
        </Switch>
      </Router>
    </>
  );
}

